import PropTypes from 'prop-types';
import React from 'react';
import ResourceProperty from '../../../common/resource/ResourceProperty';
import { tzNormalizeDate } from '../../../../utils/date';
import { FULL_DATE_TIME_FORMAT } from '../../../../config/locale';
import EnumStatus from '../../../common/EnumStatus';
import { DELIVERY_PRICE_STATUS } from '../../../../config/constants';
import LinkToModuleResource from '../../../common/resource/LinkToModuleResource';

const DeliveryPostalCodeBasicInformationResource = ({
  id,
  createDate,
  file,
  status,
  user,
  locationId,
  location,
}) => (
  <>
    <ResourceProperty label="ID:">{id}</ResourceProperty>
    <ResourceProperty label="Archivo:">
      <LinkToModuleResource
        href={file}
        text={file}
        colorIcon="text-primary"
        isExternalPath
      />
    </ResourceProperty>

    <ResourceProperty label="Estado:">
      <EnumStatus enumObject={DELIVERY_PRICE_STATUS} enumValue={status} />
    </ResourceProperty>
    <ResourceProperty label="Código de Ubicación:">
      {locationId}
    </ResourceProperty>
    <ResourceProperty label="Ubicación:">{location.name}</ResourceProperty>
    <ResourceProperty label="Creado por:">{user.fullName}</ResourceProperty>
    <ResourceProperty label="Fecha de Creación:">
      {tzNormalizeDate({ date: createDate, format: FULL_DATE_TIME_FORMAT })}
    </ResourceProperty>
  </>
);

DeliveryPostalCodeBasicInformationResource.propTypes = {
  id: PropTypes.number.isRequired,
  createDate: PropTypes.number.isRequired,
  file: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  user: PropTypes.shape({
    fullName: PropTypes.string.isRequired,
  }).isRequired,
  locationId: PropTypes.string.isRequired,
  location: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    address: PropTypes.string,
  }).isRequired,
};

export default DeliveryPostalCodeBasicInformationResource;
